import { Helmet } from "react-helmet-async";
import React, { useEffect, useContext, useState, useRef } from 'react';
import arrow1 from '../assets/img/Arrow1.png';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import API from '../pages/Services/Baseservice';
import { LanguageContext } from '../pages/languagecontext';
import ClipLoader from "react-spinners/ClipLoader";
import reactangle3 from '../assets/img/FAQ.png';
import SEO from "./SEO";
import { getServiceSEO } from "./seoConfig";
import { slugify } from '../utils/slugify';

const ServicesAsra = () => {
    const { slug } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const { selectedLanguage } = useContext(LanguageContext);
    const [service, setService] = useState(null);
    const [loading, setLoading] = useState(true);
    const [ourservicePage, setOurServicePage] = useState("");
    const [ourservice, setOurService] = useState("");
    const [listitems, setListItems] = useState("");
    const [howitworks, setHowItWorks] = useState("");
    const [card, setCard] = useState("");
    const [faq, setFaq] = useState("");
    const [servicesList, setServiceList] = useState([]);
    const [currentServiceIndex, setCurrentServiceIndex] = useState(1);
    const imageRef = useRef(null);
    const contentRef = useRef(null);
    const parentRef = useRef(null);

    // Get service ID from location state
    const serviceId = location.state?.id;

    // Fetch service data for SEO
    useEffect(() => {
        if (serviceId) {
            API.post("webourserviceFullList/getServiceById", {
                listofservice_id: serviceId,
                language_id: selectedLanguage.id
            }).then(response => {
                if (response.data.success) {
                    setService(response.data.data);
                }
                setLoading(false);
            });
        } else {
            setLoading(false);
        }
    }, [serviceId, selectedLanguage.id]);

    // Get SEO data based on service
    const seoData = service ? getServiceSEO(serviceId, selectedLanguage.id, service) : null;

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Sticky image scroll effect
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerWidth < 992) {
                if (imageRef.current) {
                    imageRef.current.style.position = "static";
                    imageRef.current.style.top = "auto";
                    imageRef.current.style.width = "100%";
                }
                return;
            }
            if (!imageRef.current || !contentRef.current || !parentRef.current) return;

            const image = imageRef.current;
            const content = contentRef.current;
            const parent = parentRef.current;

            const imageHeight = image.offsetHeight;
            const contentHeight = content.offsetHeight;
            const scrollTop = window.scrollY;
            const parentTop = parent.offsetTop;

            const header = document.querySelector('header') || document.querySelector('.header');
            const headerHeight = header ? header.offsetHeight : 80;
            const offsetTop = headerHeight + 20;

            if (imageHeight >= contentHeight) {
                image.style.position = "static";
                image.style.top = "auto";
                return;
            }

            const scrollPosition = scrollTop + offsetTop;

            if (scrollPosition < parentTop) {
                image.style.position = "static";
                image.style.top = "auto";
                image.style.width = "100%";
            }
            else if (scrollPosition + imageHeight < parentTop + contentHeight) {
                image.style.position = "fixed";
                image.style.top = offsetTop + 50 + "px";
                image.style.width = image.parentElement.offsetWidth + "px";
            }
            else {
                image.style.position = "absolute";
                image.style.top = (contentHeight - imageHeight) + "px";
                image.style.width = "100%";
            }
        };

        setTimeout(handleScroll, 100);

        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);
        };
    }, [loading, card]);

    const home = () => {
        navigate("/");
    };
    const nextService = servicesList[0];
    const handlenavigate = (item) => {
        if (item.listofservice_id) {
            const slug = slugify(nextService.heading);
            navigate(`/servicedetail/${slug}`, {
                state: {
                    id: item.listofservice_id,
                    language_id: selectedLanguage.id,
                },
            });
        } else {
            console.log("No route defined for:", item.listofservice_id);
        }
    };

    useEffect(() => {
        webourservice();
        Faq();
        dropdown();
    }, [selectedLanguage.id]);

    const webourservice = () => {
        setLoading(true);
        let req = {
            language_id: selectedLanguage.id
        };
        API.post("webourserviceFullList/webCondition", req).then((response) => {
            if (response.data.success === true) {
                setOurServicePage(response.data.data || {});
                setOurService(response.data.data.ourservice[0] || {});
                setListItems((response.data.data.listitems || []).slice().sort((a, b) => a.order_by - b.order_by));
                setHowItWorks(response.data.data.howitsworks[0] || {});
                setCard(response.data.data.cards || []);
                setLoading(false);
            }
        });
    };

    const Faq = () => {
        let req = {
            category_id: "",
            search: "",
            language_id: selectedLanguage.id
        };
        API.post("/webFaqs_list/webCondition", req).then((res) => {
            if (res.data.success === true) {
                setFaq(res.data.data.data || []);
            }
        });
    };

    const faqs = faq.slice(0, 6);

    const arrowfunction = (item, index) => {
        navigate("/faq", { state: { faqIndex: index } });
    };

    const viewallfaq = (e) => {
        e.preventDefault();
        navigate("/faq", { state: { scrollToFaq: true } });
    };

    const dropdown = () => {
        let req = { language_id: selectedLanguage.id };

        API.post("weblistofservice_list/webCondition", req)
            .then((res) => {
                if (res.data.success === true) {
                    const services = res.data.data.data;
                    setServiceList(services);
                    localStorage.setItem("DropDownValue", JSON.stringify(services));

                    if (location.state?.id) {
                        const index = services.findIndex(
                            service => service.listofservice_id === location.state.id
                        );
                        setCurrentServiceIndex(index !== -1 ? index : 0);
                    }
                }
            })
            .finally(() => setLoading(false));
    };

    const navigateToExpressEntry = (e) => {
        e.preventDefault();

        if (servicesList.length === 0) return;

        const slug = slugify(nextService.heading);
        navigate(`/servicedetail/${slug}`, {
            state: {
                id: nextService.listofservice_id,
                language_id: selectedLanguage.id
            }
        });
    };

    return (
        <div style={{ overflowX: 'hidden' }}>

            <SEO
                title="Immigration services in Canada  | Canada visa consultant"
                description=" Trusted visa & immigration experts offering Immigration services in Canada for PR, work, study, and family visas with end-to-end support."
                canonical="https://asraimmigration.ca/service"
            />
            {/* SEO Component */}
            {seoData && (
                <SEO
                    title={seoData.title}
                    description={seoData.description}
                    canonical={seoData.canonical}
                    keywords={seoData.keywords}
                    ogImage={seoData.ogImage}
                />
            )}
            {loading ? (
                <div className="d-flex justify-content-center mt-5 align-items-center p-5" style={{ height: "100vh" }}>
                    <ClipLoader color="#FF050C" size={50} />
                </div>
            ) : (
                <>
                    <div className="container">
                        <section className="faq-hero container p-4 p-lg-5 rounded-5">
                            <h1>{selectedLanguage.id === 1 ? 'Services' : 'Services'}</h1>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <a href="#" onClick={(e) => { e.preventDefault(); home(); }} style={{ cursor: 'pointer' }}>
                                            {selectedLanguage.id === 1 ? 'Home' : 'Accueil'}
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item active">{selectedLanguage.id === 1 ? 'Services' : 'Services'}</li>
                                </ol>
                            </nav>
                        </section>
                        {ourservicePage?.ourservice?.length > 0 && <>
                            <section className="social-support mt-lg-5 pt-4">
                                <h6 className="text-danger text-center mt-5 mb-1 fw-bold">
                                    {ourservice.heading || 'OUR SERVICE'}
                                </h6>
                                <h2 className="fw-bold mb-5 text-center">
                                    {ourservice.title || 'Our Comprehensive Visa and Immigration Solutions'}
                                </h2>
                            </section>

                            <section className="service-section text-center mb-5 pb-5">
                                <div className="row g-4">
                                    {Array.isArray(listitems) && listitems.length > 0 ? listitems.map((item, index) => (
                                        <div className="col-lg-4 col-md-6" key={index}>
                                            <a
                                                href="#"
                                                className="nav-link"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handlenavigate(item);
                                                }}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <div className="service-card">
                                                    <img
                                                        src={item.image}
                                                        className="img-fluid service-img"
                                                        alt={item.heading || 'Service'}
                                                    />
                                                    <div className="service-content">
                                                        <div className="d-flex justify-content-between align-items-start">
                                                            <h5 className="fw-bold mb-2">{item.heading}</h5>
                                                            <span className="faq-two-arrow">
                                                                <img src={arrow1} alt="arrow" />
                                                            </span>
                                                        </div>
                                                        <p className="faq-answer">
                                                            <strong>{selectedLanguage.id === 1 ? 'Objective:' : 'Objectif:'}</strong>
                                                            {item.description ? item.description.replace(/<[^>]*>/g, '').substring(0, 100) + '...' :
                                                                'Lorem ipsum dolor sit amet consectetur. Dolor tortor accumsan enim...'}
                                                        </p>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    )) : (
                                        Array.from({ length: 6 }).map((_, index) => (
                                            <div className="col-lg-4 col-md-6" key={index}>
                                                <div className="service-card">
                                                    <div className="service-content">
                                                        <div className="d-flex justify-content-between align-items-start">
                                                            <h5 className="fw-bold mb-2">Service {index + 1}</h5>
                                                            <span className="faq-two-arrow">
                                                                <img src={arrow1} alt="arrow" />
                                                            </span>
                                                        </div>
                                                        <p className="faq-answer">
                                                            <strong>{selectedLanguage.id === 1 ? 'Objective:' : 'Objectif:'}</strong>
                                                            Lorem ipsum dolor sit amet consectetur. Dolor tortor accumsan enim...
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </section>
                        </>
                        }
                    </div>
                    {ourservicePage?.howitsworks?.length > 0 &&
                        <section className="how-it-works" ref={parentRef}>
                            <div className="container px-3">
                                <div className="row">
                                    <div className="col-lg-6 col-md-12" ref={contentRef}>
                                        <h2 className="how-title">
                                            {howitworks.title || 'How Asra Works'}
                                        </h2>

                                        {Array.isArray(card) && card.length > 0 ? card.map((item, index) => (
                                            <div className="how-step" key={index}>
                                                <div className="d-flex align-items-start">
                                                    <h3 className="me-3">{String(index + 1).padStart(2, '0')}</h3>
                                                    <div className="flex-grow-1">
                                                        <span className="step-title">{item.card || 'Consultation and Assessment -'} </span>
                                                        <span className="step-desc" dangerouslySetInnerHTML={{ __html: item.description }}></span>
                                                    </div>
                                                </div>
                                            </div>
                                        )) : null}

                                        <div style={{ height: '50px' }}></div>
                                    </div>

                                    <div className="col-lg-6 col-md-12 mt-4 mt-lg-0" style={{ position: "relative" }}>
                                        <div
                                            ref={imageRef}
                                            style={{
                                                width: '100%',
                                            }}
                                        >
                                            <img
                                                src={howitworks.image || ''}
                                                alt="How Asra Works"
                                                className="img-fluid how-img"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    }

                    <div className="container my-5 py-5 px-3">
                        <section className="service-header-section text-start mb-4">
                            <div className="container-fluid px-2 row d-flex justify-content-between align-items-center">
                                <div className="col-md-8 col-fluid">
                                    <h6 className="service-heading text-danger fw-bold">FAQ</h6>
                                    <h2 className="faq-sub-heading fw-bold">
                                        {selectedLanguage.id === 1 ? 'Frequently Asked Questions' : 'Questions fréquentes'}
                                    </h2>
                                </div>
                                <a
                                    href="#"
                                    className="service-view-all text-decoration-none col-md-4 col-lg-3 text-danger fw-bold col-fluid"
                                    onClick={viewallfaq}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className="view-all d-flex align-items-center justify-content-end">
                                        {selectedLanguage.id === 1 ? 'View All' : 'Voir tout'}
                                        <i className="bi bi-arrow-up-right-circle ms-1"></i>
                                    </div>
                                </a>
                            </div>
                        </section>
                        {faqs.length > 0 &&
                            <section className="faq-section">
                                <div className="row g-4">
                                    {Array.isArray(faqs) && faqs.length > 0 ? faqs.map((item, index) => (
                                        <div className="col-lg-4 col-md-6" key={index}>
                                            <div className="faq-two rounded-4">
                                                <div className="faq-content rounded-4">
                                                    <img src={reactangle3} alt="FAQ 1" className="faq-img rounded-4 mb-3" />

                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <h6 className="faq-question">{item.question}</h6>
                                                        <span
                                                            className="faq-two-arrow"
                                                            onClick={() => arrowfunction(item, index)}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <img src={arrow1} alt="arrow" />
                                                        </span>
                                                    </div>
                                                    <p className="faq-answer">
                                                        {item.answers ? item.answers.replace(/<[^>]*>/g, '').substring(0, 150) + '...' :
                                                            'This is a sample text that should be visible if everything works.'}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    )) : (
                                        Array.from({ length: 6 }).map((_, index) => (
                                            <div className="col-lg-4 col-md-6" key={index}>
                                                <div className="faq-two rounded-4">
                                                    <div className="faq-content rounded-4">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <h6 className="faq-question">What is the purpose of a visa?</h6>
                                                            <span className="faq-two-arrow">
                                                                <img src={arrow1} alt="arrow" />
                                                            </span>
                                                        </div>
                                                        <p className="faq-answer">
                                                            This is a sample text that should be visible if everything works.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </section>
                        }
                    </div>

                    <div className="btn-pair1 mb-3 mt-5 me-5">
                        <a
                            className="nav-link me-5"
                            href="#"
                            onClick={navigateToExpressEntry}
                            style={{ cursor: 'pointer' }}
                        >
                            <button className="btn btn-danger d-flex align-items-center justify-content-center">
                                <p className="p-0 m-0">
                                    {selectedLanguage.id === 1 ? 'Express Entry' : 'Entrée Express'}
                                </p>
                                <i className="bi bi-arrow-right-circle-fill ms-1 book-icon"></i>
                            </button>
                        </a>
                    </div>
                </>
            )}
        </div>
    );
};

export default ServicesAsra;